import $ from 'jquery'

//remove font-family from style tag and inline style - this is so that we can use our own css
const cleanDefault = (style: string) => {
    // style = style.replace(/font-family:\s?'[^;]+;/g, '')
    // style = style.replace(/(margin-left:\s?\d\dpx;)/g, '')
    style = style.replace(/(font-family:\s?'[^;]+;)|(font-family:\s?'[^;]+$)/g, '') //see api_edinet_test.js
    style = style.replace(/(width:\s?[^;]+;)|(width:\s?[^;]+$)/g, '') //see api_edinet_test.js
    // style = style.replace(/(line-height:\s?[^;]+;)|(line-height:\s?[^;]+$)/g, '')
    // style = style.replace(/(min-height:\s?[^;]+;)|(min-height:\s?[^;]+$)/g, '')
    // style = style.replace(/(font-size:\s?[^;]+;)|(font-size:\s?[^;]+$)/g, '')
    return style
}


export const cleanStyle = function($doc: JQuery, clean: (style: string, elem: Element) => string = cleanDefault) {
    //<style>...</style> tag
    $doc.find('style').each(function() {
        const $style = $(this)
        let style = $style.html()
        style = clean(style, this)
        $style.html(style)
    })

    //style="..." attribute
    // $doc.find('[style*="font-family"]').each(function() {
    $doc.find('[style]').each(function() { //for all element which contains 'style' attribute
        const $this = $(this)
        //console.log($this.attr('style'))
        let s = $this.attr('style')
        if (s) {
            s = clean(s, this).trim()
            $this.attr('style', s)
        }
    })
    return $doc
}

export const cleanStyleHtml = function(html: string) {
    return cleanStyle($(html)).html()
}

export const isGoogleTranslated = function() {
    return $('html.translated-ltr').get().length > 0
}